import { render, staticRenderFns } from "./timelineItem.vue?vue&type=template&id=4d96e3c4"
import script from "./timelineItem.vue?vue&type=script&lang=js"
export * from "./timelineItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports